require('./style.css');
var tmpl = require('./main.ejs');
var Events = require('f.core.event');

var Network = function (url) {
  this.url = url;
  this.init();
};

Network.prototype.init = function () {
  this.initDom();
  this.initEvent();
};

Network.prototype.initDom = function () {
  this.elm = $(tmpl());
};

Network.prototype.initEvent = function () {
  this.elm.on('touchend', '.c-network-btn__retry', () => {
    this.trigger('network_retry');
    return false;
  });
  this.elm.on('touchend', '.c-network-btn__continue', () => {
    this.trigger('network_continue');
    return false;
  });

  this.elm.on('touchend', () => {
    this.trigger('network_toggle');
    return false;
  });
};

Network.prototype.renderTo = function (parentNode) {
  this.elm.appendTo(parentNode);
};

Network.prototype.show = function (type) {
  if (type == 'offnet') {
    this.elm.html(`
      <div>
        <span class="c-network-content">网络连接失败</span>
        <span class="c-network-btn__retry">重试</span>
      </div>
      `);
  } else if (type == 'notWifi_videoapp') {
    this.elm.html(`
    <div>
      <span class="c-network-content">小提示<br/>您正在使用运营商网络</span>
      <span class="c-network-btn__continue">继续观看</span>
    </div>
  `);
  } else {
    this.elm.html(`
      <div>
        <span class="c-network-content">小提示<br/>您正在使用手机流量观看</span>
        <span class="c-network-btn__continue">继续观看</span>
      </div>
    `);
  }

  this.elm.css('visibility', 'visible');
};

Network.prototype.hide = function () {
  this.elm.css('visibility', 'hidden');
};

Network.prototype.destory = function () {
  this.off();
  this.elm.remove();
};

Events.mixTo(Network);

module.exports = Network;


// WEBPACK FOOTER //
// /Users/gebb/Desktop/live/modules/f.compenont.video.mobile/app/modules/network/index.js